import React, { FC } from 'react'

import { IconSignedInProps } from './IconSignedIn.types'
import * as Styled from './styles/IconSignedIn.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSignedIn: FC<IconSignedInProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSignedInProps['size'],
  isResponsive = false,
}: IconSignedInProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M9.344 42c0-9.727 6.554-17.61 14.644-17.61 4.649 0 8.79 2.606 11.473 6.669'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M32.25 15.316A8.269 8.269 0 1 1 24 7.05h8.25v8.266Z' stroke='#0D0D0D' strokeWidth='2' />
        <path d='m42.996 32.172-8.824 8.824-3.922-3.922' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSignedIn
